export default function () {
    return {
        restrict: 'E',
        bindToController: {
            vehicleId: '=',
            details: '=',
            notes: '=',
            enquiryId: '='
        },
        template: require('./enquiry-progress.html'),
        controller: enquiryProgressCtrl,
        controllerAs: 'enquiryProgress'
    };
}

function enquiryProgressCtrl($interval, $scope, discrepancyResolvedState, openAddNoteModal, openListNoteModal, openDiscrepancyResolveStateModal, updateBillingDetails, currentUser, $state) {
    const vm = this;
    vm.areAllDiscrepanciesResolved = null;
    vm.billingEditMode = [];
    vm.updateForms = [];

    /* --- */
    vm.populateUpdateForms = populateUpdateForms;
    vm.populateBillingEdit = populateBillingEdit;
    vm.addNoteToDiscrepancy = addNoteToDiscrepancy;
    vm.viewNotesForDiscrepancy = viewNotesForDiscrepancy;
    vm.resolveDiscrepancy = resolveDiscrepancy;
    vm.editBilling = editBilling;
    vm.saveBilling = saveBilling;
    vm.cancelEditBilling = cancelEditBilling;
    vm.isBillingInEditMode = isBillingInEditMode;
    vm.toggleBillingEditMode = toggleBillingEditMode;
    vm.currentUser = null;

    vm.$onInit = function() {
        populateUpdateForms();
        populateBillingEdit();
    }

    /* --- */

    // watcher

    $scope.$watch(() => vm.discrepancies, () => updateAllDiscrepanciesStatus(), true);

    /* --- */
    currentUser()
        .then(result => {
            vm.currentUser = result;
        });


    function populateUpdateForms() {
        vm.updateForms = vm.details.enquiriesDetails.map(e => {
            return {
                ...e.billingHistory,
                updatedHasV5: e.billingHistory.currentHasV5,
                updatedHasForm1: e.billingHistory.currentHasForm1
            };
        });
    }

    function populateBillingEdit() {
        vm.billingEditMode = vm.details.enquiriesDetails.map(() => {
            return {
                edit: false
            };
        });
    }

    function updateAllDiscrepanciesStatus() {
        vm.details.discrepancies.map(discrepancy => {
            discrepancy.isResolved = discrepancy.resolvedState === discrepancyResolvedState.resolved;
            return discrepancy;
        });

        vm.areAllDiscrepanciesResolved = vm.details.discrepancies.every(d => d.isResolved);
    }

    function addNoteToDiscrepancy(discrepancy) {
        openAddNoteModal(vm.notes, vm.details.discrepancies, discrepancy.id);
    }

    function viewNotesForDiscrepancy(discrepancy) {
        const notes = vm.notes.filter(x => x.discrepancyId = discrepancy.id);

        openListNoteModal(notes);
    }

    function resolveDiscrepancy(discrepancy) {
        openDiscrepancyResolveStateModal(vm.vehicleId, discrepancy)
        .then(modal => modal.close)
        .then(() => {
            updateAllDiscrepanciesStatus();
        });
    }

    function editBilling(index) {
        vm.toggleBillingEditMode(index);
    }

    function cancelEditBilling(index) {
        vm.updateForms[index].updatedHasForm1 = vm.details.enquiriesDetails[index].billingHistory.currentHasForm1;
        vm.updateForms[index].updatedHasV5 = vm.details.enquiriesDetails[index].billingHistory.currentHasV5;

        vm.toggleBillingEditMode(index);
    }

    function saveBilling(index) {
        if (!(vm.currentUser.isAdmin || vm.currentUser.isOperator)) {
            $state.go('noaccess');
            return;
        }

        if (vm.updateForms[index].updatedHasForm1 !== vm.details.enquiriesDetails[index].billingHistory.currentHasForm1 ||
            vm.updateForms[index].updatedHasV5 !== vm.details.enquiriesDetails[index].billingHistory.currentHasV5) {
            const updateBillingDetailsModel = {
                hasForm1: vm.updateForms[index].updatedHasForm1 ? vm.updateForms[index].updatedHasForm1 : false,
                hasV5: vm.updateForms[index].updatedHasV5 ? vm.updateForms[index].updatedHasV5 : false
            };

            updateBillingDetails(vm.vehicleId, vm.details.enquiriesDetails[index].id, updateBillingDetailsModel)
                .then(() => {
                    vm.details.enquiriesDetails[index].billingHistory.currentHasForm1 = vm.updateForms[index].updatedHasForm1;
                    vm.details.enquiriesDetails[index].billingHistory.currentHasV5 = vm.updateForms[index].updatedHasV5;

                    vm.toggleBillingEditMode(index);
                });
        }
    }

    function isBillingInEditMode(index) {
        return vm.billingEditMode[index].edit;
    }

    function toggleBillingEditMode(index) {
        const isInEditMode = isBillingInEditMode(index);

        if (isInEditMode) {
            vm.billingEditMode[index].edit = false;
        } else {
            vm.billingEditMode[index].edit = true;
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/directives/enquiryProgress/index.js